import { Inject, Injectable, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ScriptService {
  scripts: any = {
    'QAnL&F': 'https://qas.pay.button.epago.pe/web/1.0.0-beta/sdk.js',
    'QAV1': 'https://qas.pay.button.epago.pe/web/latest/sdk.js',
    'QAV2': 'https://qas.pay.button.epago.pe/web/ncore-1.0.0/sdk.js',
    'QAS_PA': 'https://qas.pay.button.epago.pe/web/pa-1.0.0/sdk.js',
    'PROD': 'https://pay.button.epago.pe/web/latest/sdk.js',
    'PROD/QA': 'https://pay.button.epago.pe/web/latest/sdk.js',
    'DEV': 'https://dev.pay.button.epago.pe/web/1.0.0/sdk.js',
    'SDK_VERSION_OLD': 'https://qas.pay.button.epago.pe/web/old-1.0.0/sdk.js',
    'PRODCORD': 'https://pay.button.epago.pe/web/cord-1.0.0/sdk.js',
    'REACT_SDK': 'https://qas.pay.button.epago.pe/web/react-sdk-1.0.0/sdk.js',
    'REACT_SDK_DEV': 'https://dev.pay.button.epago.pe/web/react-sdk-1.0.0/sdk.js',
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadJsScript(renderer: Renderer2, env: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = this.scripts[env];
    renderer.appendChild(this.document.body, script);
    return script;
  }

  public removeScript(): void {
    const script = document.getElementById("epago-script");
    if (script) {
      this.document.removeChild(script);
    }
  }

  private reactSdkModulePromises = new Map<string, Promise<unknown>>();
  public normalizeReactSdkUrl(url: string): string {
    const trimmed = url.trim().replace(/\/+$/, '');
    if (!trimmed) {
      return trimmed;
    }
    try {
      const base = this.document.baseURI || (typeof window !== 'undefined' ? window.location.href : '');
      const u = new URL(trimmed, base);
      const path = u.pathname;
      if (/\.(umd|es)\.m?js$/i.test(path) || /\.mjs$/i.test(path)) {
        return trimmed;
      }
      if (/index\.tsx?$/i.test(path)) {
        return trimmed;
      }
      if (/\.(js|mjs)$/i.test(path)) {
        return trimmed;
      }
      u.pathname = path.replace(/\/+$/, '') + '/epago-sdk.umd.js';
      return u.toString();
    } catch {
      return trimmed;
    }
  }

  public loadReactSdkEsmModule(moduleUrl: string): Promise<{ Form?: new (config: unknown) => { render: (s: string) => void; unmount: () => void }; default?: { Form?: new (config: unknown) => { render: (s: string) => void; unmount: () => void } } }> {
    let p = this.reactSdkModulePromises.get(moduleUrl);
    if (!p) {
      p = import(/* webpackIgnore: true */ moduleUrl).catch((err: unknown) => {
        this.reactSdkModulePromises.delete(moduleUrl);
        throw err;
      });
      this.reactSdkModulePromises.set(moduleUrl, p);
    }
    return p as Promise<{
      Form?: new (config: unknown) => { render: (s: string) => void; unmount: () => void };
      default?: { Form?: new (config: unknown) => { render: (s: string) => void; unmount: () => void } };
    }>;
  }


  public loadReactSdkUmdScript(scriptUrl: string): Promise<void> {
    const w = window as unknown as { Epago?: { Form?: new (config: unknown) => unknown } };
    if (typeof w.Epago?.Form === 'function') {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = this.document.createElement('script');
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => {
        if (typeof (window as unknown as { Epago?: { Form?: unknown } }).Epago?.Form === 'function') {
          resolve();
        } else {
          reject(new Error('epago-sdk.umd.js cargado pero window.Epago.Form no existe'));
        }
      };
      script.onerror = () => reject(new Error(`No se pudo cargar ${scriptUrl}`));
      this.document.body.appendChild(script);
    });
  }

  public ensureReactSdkStylesheet(sdkJsUrl: string): void {
    const id = 'epago-react-sdk-styles';
    if (this.document.getElementById(id)) {
      return;
    }
    let href: string;
    try {
      const base = this.document.baseURI || (typeof window !== 'undefined' ? window.location.href : '');
      const url = new URL(sdkJsUrl, base);
      if (!/\/epago-sdk\.(umd|es)\.js$/i.test(url.pathname)) {
        return;
      }
      url.pathname = url.pathname.replace(/\/epago-sdk\.(umd|es)\.js$/i, '/epago-sdk.css');
      href = url.toString();
    } catch {
      return;
    }
    const link = this.document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    this.document.head.appendChild(link);
  }

  public getReactSdkFormFromGlobal(): new (config: unknown) => { render: (s: string) => void; unmount: () => void } {
    const FormCtor = (window as unknown as { Epago?: { Form?: new (config: unknown) => unknown } }).Epago?.Form;
    if (typeof FormCtor !== 'function') {
      throw new Error('window.Epago.Form no está disponible. Carga primero epago-sdk.umd.js.');
    }
    return FormCtor as new (config: unknown) => { render: (s: string) => void; unmount: () => void };
  }
}